import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { CampaignApi, FindOptions } from 'api';

export const findCampaign = createAsyncThunk(
  'campaign/findCampaign',
  async (option: FindOptions, { rejectWithValue }) => {
    try {
      const response = await CampaignApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  tableList: Array<any>;
}

const initialState: IState = {
  list: [],
  tableList: [],
};

const campaignSlice = createSlice({
  name: 'campaign',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findCampaign.fulfilled, (state, action) => {
      const { data } = action.payload;
      const newData = data.map((item: any) => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;
    });
  },
});

const { reducer: campaignReducer } = campaignSlice;

export default campaignReducer;
